import React, { Component } from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import { isSortCodeValid } from '../../../utils/validation';
import { checkEmptyFieldValue } from '../../../utils';
import { SORT_FIELD1, SORT_FIELD2, SORT_FIELD3 } from '../../../utils/constants';

const required = allValues => {
  if (allValues !== undefined && allValues !== null && isSortCodeValid(allValues)) {
    return undefined;
  }
  return 'Required';
};

const checkField = value => {
  return checkEmptyFieldValue(document.getElementById(value));
};

class OldSortcode extends Component {
  constructor(props) {
    super(props);
    this.autoTab = this.autoTab.bind(this);
    this.state = { touched: false };
    this.onInputBlur = this.onInputBlur.bind(this);
  }

  autoTab(e, value, sortField, len, field2) {
    if (
      checkField(sortField) &&
      checkField(field2) &&
      document.getElementById(sortField).value.length === len
    ) {
      document.getElementById(field2).focus();
    }
    this.props.input.onChange({ ...value, [sortField]: e.target.value });
  }

  onInputBlur(value) {
    if (!value || isNaN(value) || value.length < 2) {
      this.setState({ touched: true });
    }
  }

  render() {
    const {
      input: { value },
      meta: { touched, error }
    } = this.props;
    return (
      <Content>
        {({ sortCodeHeader, sortCodeError }) => (
          <FormField>
            <FieldHeader
              name="sortCode"
              hasError={(this.state.touched || touched) && !!error}
              title={sortCodeHeader}
              validationMessage={sortCodeError}
            />
            <FieldBody hasError={(this.state.touched || touched) && !!error}>
              <BlockFieldColumn column={1}>
                <Input
                  type="tel"
                  maxLength={2}
                  id={SORT_FIELD1}
                  value={value.sortField1}
                  onBlur={e => {
                    this.onInputBlur(e.target.value);
                  }}
                  onChange={e => this.autoTab(e, value, SORT_FIELD1, 2, SORT_FIELD2)}
                />
              </BlockFieldColumn>
              <BlockFieldColumn column={1}>
                <Input
                  type="tel"
                  id={SORT_FIELD2}
                  maxLength={2}
                  value={value.sortField2}
                  onBlur={e => {
                    this.onInputBlur(e.target.value);
                  }}
                  onChange={e => this.autoTab(e, value, SORT_FIELD2, 2, SORT_FIELD3)}
                />
              </BlockFieldColumn>
              <BlockFieldColumn column={1}>
                <Input
                  type="tel"
                  id={SORT_FIELD3}
                  maxLength={2}
                  value={value.sortField3}
                  onBlur={e => {
                    this.onInputBlur(e.target.value);
                  }}
                  onChange={e => this.autoTab(e, value, SORT_FIELD3)}
                />
              </BlockFieldColumn>
            </FieldBody>
          </FormField>
        )}
      </Content>
    );
  }
}

OldSortcode.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.object
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

const SortCodeField = () => (
  <Field
    name="oldSortCode"
    value={{ sortField1: '', sortField2: '', sortField3: '' }}
    component={OldSortcode}
    validate={required}
  />
);

export default SortCodeField;
